module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-Bold.36b6cffd.woff2";